import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import createInfo from "./CourseInfoCreate.module.css";
import Select, { components } from "react-select";
import { customStyles } from "../../../../../pages/customStyles";
import { AxiosInstance } from "../../../../../axios";
import { ImageUrlPrefix } from "../../../../../labels";
import { Download } from "@mui/icons-material";
import Creatable from "react-select/creatable";
import toast from "react-hot-toast";
import Loader from "../../../Loader";
import moment from "moment";
import fileDownload from "js-file-download";
import { common } from "@mui/material/colors";
import axios from "axios";
export default function CourseInfoCreate() {
  const { id } = useParams();

  const [aaOption, AAOption] = useState([
    {
      value: 0,
      label: "Course",
    },
    {
      value: 1,
      label: "Test",
    },
    {
      value: 3,
      label: "Special Class",
    },
    {
      value: 4,
      label: "Model Exam",
    },
    {
      value: 2,
      label: "Counselling",
    },
    {
      value: 5,
      label: "Mock Interview",
    },
  ]);
  const regex = /^[0-9]+(\.[0-9]+)?$/; // Matches integers or decimals
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const navigate = useNavigate();
  const [ccategory, setCcategory] = useState([]);
  const [subcategorys, setSubcategorys] = useState([]);
  const [common_groupName, setCommon_groupName] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [initialfields, setInitialfields] = useState({
    AAdmissionType: "",
    AAdmissionTypeLabel: "",
    Category: "",
    CategoryTypeLabel: "",
    CourseGrouping: "",
    CourseGroupingLabel: "",
    CommonGroupingLabel: "",
    CommonGrouping: "",
    CourseName: "",
    content_path: null,
    content_path_original: null,
  });

  const [error, setError] = useState({});

  /**fetch the data for Category */
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        const ccategory = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));

        setCcategory(ccategory);
      })
      .catch((error) => {
        return error;
      });
  }, []);

  useEffect(() => {
    AxiosInstance.get(`/api/course/getGroupCourse`)
      .then((res) => {
        const uniqueSubcategories = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));
        setCommon_groupName(uniqueSubcategories);
      })
      .catch((error) => {
        console.error(error); // Log the error for debugging
        return error;
      });
    // }
  }, [initialfields]);

  // fetch group header
  useEffect(() => {
    const sub_category = {
      // type: initialfields.AAdmissionType,
      type: "",
      category_id: initialfields.Category,
    };
    AxiosInstance.post(`/api/course/sub_category_list`, sub_category)
      .then((res) => {
        const uniqueSubcategories = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.name,
        }));
        setSubcategorys(uniqueSubcategories);
      })
      .catch((error) => {
        console.error(error); // Log the error for debugging
        return error;
      });
    // }
  }, [initialfields]);

  useEffect(() => {
    if (id) {
      AxiosInstance.post(`api/course/courseview`, { id: id })
        .then((res) => {
          setIsLoading(true);
          if (res.data.status === true) {
            setIsLoading(false);
            let typeLabel;
            if (res.data.data[0].type === 0) {
              typeLabel = "Course";
            } else if (res.data.data[0].type === 1) {
              typeLabel = "Test";
            } else if (res.data.data[0].type === 2) {
              typeLabel = "Counselling";
            } else if (res.data.data[0].type === 3) {
              typeLabel = "SpecialClass";
            } else if (res.data.data[0].type === 4) {
              typeLabel = "ModelExam";
            } else if (res.data.data[0].type === 5) {
              typeLabel = "MockInterview";
            }

            setInitialfields({
              AAdmissionType: res.data.data[0].type,
              AAdmissionTypeLabel: typeLabel,
              Category: res.data.data[0].category_id,
              CategoryTypeLabel: res.data.data[0].category,
              CourseGrouping: res.data.data[0].subcategory_id,
              CourseGroupingLabel: res.data.data[0].subcategory_code,
              CommonGroupingLabel: res.data.data[0].group_course_name,
              CommonGrouping: res.data.data[0].group_course_id,
              CourseName: res.data.data[0].course_name,
              content_path: res.data.data[0].course_content_path,
              content_path_original:
                res.data.data[0].course_content_original_path,
            });
          } else {
            setIsLoading(false);
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          return error;
        });
    }
  }, [id]);

  const handlechangeSelectDropdown = (option, dname, editPage) => {
    if (dname === "AAdmissionType") {
      if (editPage) {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: option.value,
          ["AAdmissionTypeLabel"]: option.label,
          // ["Category"]: "",
        }));
        setSubcategorys([]);
        setError({
          ...error,
          [dname]: "",
        });
      } else {
        setInitialfields((prevState) => ({
          ...prevState,
          [dname]: option,
          ["AAdmissionTypeLabel"]: option.map((opt) => opt.label).join(", "),
          // ["Category"]: "",
        }));
        setSubcategorys([]);
        setError({
          ...error,
          [dname]: "",
        });
      }
    } else if (dname === "Category") {
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: option.value,
        ["CategoryTypeLabel"]: option.label,
        ["CourseGroupingLabel"]: "",
      }));
      // setSubcategorys([]);
      setError({
        ...error,
        [dname]: "",
      });
    } else if (dname === "CommonGrouping") {
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: option.value,
        ["CommonGroupingLabel"]: option.label,
      }));
      setError({
        ...error,
        [dname]: "",
      });
    } else if (dname === "CourseGrouping") {
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: option.value,
        ["CourseGroupingLabel"]: option.label,
      }));
      setError({
        ...error,
        [dname]: "",
      });
    } else if (dname === "CommonGrouping") {
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: option.value,
        ["CommonGroupingLabel"]: option.label,
      }));
      setError({
        ...error,
        [dname]: "",
      });
    }
  };

  const handleChange = (event) => {
    const { name, files, value } = event.target;

    // Handle file input for content_path
    if (name === "content_path") {
      const file = files?.[0];
      const fileName = file?.name || "";

      // Reset any previous error
      let newError = { ...error };

      // If a file is selected
      if (file) {
        // Check if the file name matches the original
        // if (id) {
        //   if (
        //   initialfields.content_path_original &&
        //   initialfields.content_path_original !== fileName
        // ) {
        //   newError[name] =
        //     "Please ensure the current file name matches the original downloaded file.";
        //   setError(newError);
        //   return;
        // }
        // }

        // Check for file type
        if (file.type !== "text/html") {
          setInitialfields((prev) => ({
            ...prev,
            content_path: null,
            content_path_original: null,
          }));
          newError[name] = "Only HTML files are allowed.";
          setError(newError);
          return;
        }

        // Upload the valid HTML file
        const formData = new FormData();
        formData.append("course_content_sheet", file);

        AxiosInstance.post("api/upload/", formData)
          .then((res) => {
            setInitialfields((prev) => ({
              ...prev,
              content_path: res.data.path,
              content_path_original: res.data.originalname,
            }));
            newError[name] = "";
            setError(newError);
          })
          .catch((err) => {
            console.error("Upload failed", err);
            newError[name] = "Upload failed. Please try again.";
            setError(newError);
          });
      } else {
        // If no file selected, reset the values
        setInitialfields((prev) => ({
          ...prev,
          content_path: null,
          content_path_original: null,
        }));
        newError[name] = "";
        setError(newError);
      }
    } else {
      // Handle non-file inputs
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  };

  // Ref
  const course_ref = useRef(null);
  const type_of_admission_ref = useRef(null);
  const category_ref = useRef(null);
  const sub_category_ref = useRef(null);
  const upload_course_content_ref = useRef(null);

  // Validation error
  const validateFields = (data) => {
    const errors = { ...error };
    if (!data.CourseName) {
      errors.CourseName = "Please enter a  course";
    }
    if (data.AAdmissionType === "" || data.AAdmissionType.length === 0) {
      errors.AAdmissionType = "Please select an type of admission";
    }
    if (data.Category === "") {
      errors.Category = "Please select a  category";
    }
    if (
      (!data.CourseGrouping || !data.CourseGroupingLabel) &&
      data.AAdmissionType !== 2 &&
      data.AAdmissionType !== 5
    ) {
      errors.CourseGrouping = "Please select a sub category";
    }
    if (!data.CommonGrouping) {
      errors.CommonGrouping = "Please select a course group name";
    }
    // if (!data.content_path) {
    //   errors.content_path = "Please upload a valid HTML file";
    // }
    validateFocusCommentSection(data);
    return errors;
  };

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.CourseName) {
      course_ref.current.focus();
    } else if (!COMSECFO.AAdmissionType) {
      type_of_admission_ref.current.focus();
    } else if (!COMSECFO.Category) {
      category_ref.current.focus();
    } else if (!COMSECFO.CourseGrouping) {
      sub_category_ref.current.focus();
    } else if (!COMSECFO.content_path) {
      if (upload_course_content_ref && upload_course_content_ref.current) {
        upload_course_content_ref.current.focus();
      } else {
        console.error(
          "upload_course_content_ref is not properly set or does not have a valid DOM element."
        );
      }
    }
  };

  const handleSubmit = () => {
    const err_bnh = validateFields(initialfields);
    if (Object.values(err_bnh).every((value) => value === "")) {
      try {
        if (id) {
          // If an id is provided, update the data
          const updateCoures = {
            id: id,
            category_code: initialfields.CategoryTypeLabel,
            subcategory_code: initialfields.CourseGroupingLabel || "",
            common_group_name: initialfields.CommonGroupingLabel || "",
            common_group_id: initialfields.CommonGrouping || "",
            course_name: initialfields.CourseName,
            category_id: initialfields.Category,
            subcategory_id:
              initialfields.CourseGrouping !== null
                ? initialfields.CourseGrouping
                : 0,
            type: initialfields.AAdmissionType,
            course_content_path: initialfields.content_path
              ? initialfields.content_path
              : null,
            course_content_original_path: initialfields.content_path_original
              ? initialfields.content_path_original
              : null,
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
          };
          AxiosInstance.post(`api/course/courseAdd`, updateCoures)
            .then((res) => {
              if (res.data.status === true) {
                toast.success(res.data.message);
                navigate(-1);
              } else {
                if (res.data?.courseErr) {
                  // setError((prev) => ({
                  //   ...prev,
                  //   CourseName: res.data.courseErr,
                  // }));
                  toast.error(res.data.courseErr);
                  navigate(-1);
                } else if (res.data?.type_of_admission) {
                  setError((prev) => ({
                    ...prev,
                    CourseName: res.data.type_of_admission,
                  }));
                } else {
                  toast.error(res.data.message);
                }
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          // If no id is provided, add the new data
          const createCouresInfoData = {
            id: "",
            category_code: initialfields.CategoryTypeLabel,
            subcategory_code: initialfields.CourseGroupingLabel || "",
            common_group_name: initialfields.CommonGroupingLabel || "",
            common_group_id: regex.test(initialfields.CommonGrouping)
              ? initialfields.CommonGrouping
              : "",
            course_name: initialfields.CourseName,
            category_id: initialfields.Category,
            subcategory_id: regex.test(initialfields.CourseGrouping)
              ? initialfields.CourseGrouping
              : "",
            type: initialfields?.AAdmissionType?.map((item) => item.value),
            course_content_path: initialfields.content_path
              ? initialfields.content_path
              : null,
            course_content_original_path: initialfields.content_path_original
              ? initialfields.content_path_original
              : null,
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
          };

          AxiosInstance.post(`api/course/courseAdd`, createCouresInfoData)
            .then((res) => {
              if (res.data.status === true) {
                toast.success(res.data.message);
                navigate("/CourseManagement/1");
              } else {
                if (res.data?.type_of_admission) {
                  setError((prev) => ({
                    ...prev,
                    CourseName: res.data.type_of_admission,
                  }));
                } else {
                  toast.error(res.data.message);
                }
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };
  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${initialfields.content_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };

  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: 8 }}
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit Course" : "Create New Course"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/CourseManagement/1"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Course" : "Back to Course Management"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Course
              </Link>
            </li>
          </ul>
        </div>
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Course Details</legend>
            <form className="row g-3">
              <div class="col-md-6">
                <label for="CourseName" class="form-label confirm_value ">
                  Course
                </label>
                <input
                  ref={course_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="text"
                  id="CourseName"
                  name="CourseName"
                  placeholder="Enter the course"
                  value={initialfields.CourseName}
                  onChange={handleChange}
                />
                {error.CourseName && (
                  <small className="error_message">{error.CourseName}</small>
                )}
              </div>
              <div className="col-md-6">
                <label
                  for="AAdmissionType"
                  class={
                    id
                      ? "form-label confirm_value disabled_btn"
                      : "form-label confirm_value "
                  }
                >
                  Type of Admission
                </label>
                {!id ? (
                  <Select
                    ref={type_of_admission_ref}
                    className={`shadow-none input-font-size ${
                      id ? "disabled_btn" : ""
                    }`}
                    // isDisabled={!!id}
                    name="AAdmissionType"
                    value={initialfields.AAdmissionType || []}
                    onChange={(options) =>
                      handlechangeSelectDropdown(options, "AAdmissionType")
                    }
                    options={aaOption}
                    isMulti
                    isSearchable
                    placeholder="Select type of admission"
                    maxMenuHeight={200}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CheckboxOption }}
                    styles={customStyles}
                  />
                ) : (
                  <Select
                    ref={type_of_admission_ref}
                    className={`shadow-none input-font-size`}
                    isDisabled={!!id}
                    name="AAdmissionType"
                    value={
                      initialfields.AAdmissionTypeLabel !== null &&
                      initialfields.AAdmissionType !== ""
                        ? {
                            value: initialfields.AAdmissionType,
                            label: initialfields.AAdmissionTypeLabel,
                          }
                        : null
                    }
                    onChange={(option) =>
                      handlechangeSelectDropdown(
                        option,
                        "AAdmissionType",
                        "editPage"
                      )
                    }
                    options={aaOption}
                    isSearchable
                    placeholder="Select type of admission"
                    maxMenuHeight={200}
                    filterOption={(option, searchText) =>
                      option.label
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    }
                    styles={customStyles}
                  />
                )}

                {error.AAdmissionType && (
                  <small className="error_message">
                    {error.AAdmissionType}
                  </small>
                )}
              </div>
              <div class="col-md-6">
                <label
                  for="Category"
                  class={
                    id
                      ? "form-label confirm_value disabled_btn"
                      : "form-label confirm_value "
                  }
                >
                  Category
                </label>
                <Select
                  ref={category_ref}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="Category"
                  value={
                    initialfields.CategoryTypeLabel !== null &&
                    initialfields.Category !== ""
                      ? {
                          value: initialfields.Category,
                          label: initialfields.CategoryTypeLabel,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "Category")
                  }
                  options={ccategory}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select category"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                />

                {error.Category && (
                  <small className="error_message">{error.Category}</small>
                )}
              </div>
              <div class="col-md-6">
                <label
                  for="CourseGrouping"
                  class={
                    id
                      ? "form-label confirm_value disabled_btn"
                      : "form-label confirm_value "
                  }
                >
                  Course Group Name
                </label>
                <Creatable
                  ref={sub_category_ref}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="CommonGrouping"
                  value={
                    initialfields.CommonGroupingLabel &&
                    initialfields.CommonGrouping
                      ? {
                          value: initialfields.CommonGrouping,
                          label: initialfields.CommonGroupingLabel,
                        }
                      : undefined // Ensure undefined, not null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "CommonGrouping")
                  }
                  options={common_groupName
                    ?.filter((item) => item && item.label)
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true}
                  placeholder="Select or enter new course group name"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                  formatCreateLabel={(inputValue) => `Add New : ${inputValue}`}
                />
                {error.CommonGrouping && (
                  <small className="error_message">
                    {error.CommonGrouping}
                  </small>
                )}
              </div>
              <div class="col-md-6">
                <label
                  for="CourseGrouping"
                  class={
                    id
                      ? "form-label confirm_value disabled_btn"
                      : "form-label confirm_value "
                  }
                >
                  Sub Category
                </label>
                <Creatable
                  ref={sub_category_ref}
                  className={`shadow-none input-font-size ${
                    id ? "disabled_btn" : ""
                  }`}
                  isDisabled={id ? true : false}
                  name="CourseGrouping"
                  value={
                    initialfields.CourseGroupingLabel !== null &&
                    initialfields.CourseGrouping !== ""
                      ? {
                          value: initialfields.CourseGrouping,
                          label: initialfields.CourseGroupingLabel,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handlechangeSelectDropdown(option, "CourseGrouping")
                  }
                  options={subcategorys
                    ?.filter((item) => item && item.label) // Filter out null and undefined elements
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select or enter new sub category"
                  maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  } // Filter options based on the search text
                  styles={customStyles} // Apply custom styles her
                  formatCreateLabel={(inputValue) => `Add New : ${inputValue}`} // Customize the create label
                />
                {error.CourseGrouping && (
                  <small className="error_message">
                    {error.CourseGrouping}
                  </small>
                )}
              </div>
            </form>
          </fieldset>

          <fieldset className="mt-3">
            <legend className="w-auto">Course Content</legend>
            <form className="row g-3">
              <div className="col-lg-6 col-md-12">
                <div className="forms ">
                  <div className="d-flex">
                    <div className="row">
                      <label for="formFile" class={` form-label confirm_value`}>
                        Upload Course Content {"(Optional)"}
                        {/* {initialfields.content_path_original
                          ? initialfields.content_path_original
                          : ""} */}
                      </label>
                    </div>
                    {/* {initialfields.content_path !== "" &&
                      initialfields.content_path !== null && (
                        <div className={"d-flex align-content-center p-0"}>
                          {initialfields.content_path !== "" &&
                            initialfields.content_path !== null && (
                              <>
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${initialfields.content_path}`}
                                >
                                  <Download className="download_icon" />
                                </a>
                              </>
                            )}
                        </div>
                      )} */}

                    {initialfields.content_path !== null &&
                      initialfields.content_path !== "" && (
                        <a
                          to="javascript:void(0)"
                          onClick={() =>
                            handleDownload(
                              initialfields.content_path,
                              initialfields.content_path_original
                            )
                          }
                        >
                          <span
                            className={`${createInfo.mui_icon} material-icons   align-middle mx-1`}
                          >
                            file_download
                          </span>
                        </a>
                      )}
                  </div>
                  <div className="row">
                    <div
                      className={
                        initialfields.content_path !== "" &&
                        initialfields.content_path !== null
                          ? "col-md-3 col-5 "
                          : "col-md-12"
                      }
                    >
                      <input
                        ref={upload_course_content_ref}
                        type="file"
                        className={
                          initialfields.content_path !== "" &&
                          initialfields.content_path !== null
                            ? "InputsSelectFile nn_upload_width"
                            : "InputsSelectFile  vv_upload_width"
                        }
                        placeholder="Enter question path"
                        required
                        id="content_path"
                        onChange={handleChange}
                        name="content_path"
                      />
                    </div>
                    {initialfields.content_path !== "" &&
                      initialfields.content_path !== null && (
                        <div
                          className={
                            "col-md-9 col-7 d-flex  align-content-center p-0"
                          }
                        >
                          <span className="nn_upload_fileevaluator">
                            {initialfields.content_path !== "" &&
                            initialfields.content_path !== null
                              ? initialfields.content_path_original
                              : ""}
                          </span>
                          {initialfields.content_path !== "" &&
                            initialfields.content_path !== null && (
                              <>
                                <span
                                  className={`${createInfo.verified_uploadeval} material-icons align-middle text-danger`}
                                >
                                  verified
                                </span>
                              </>
                            )}
                        </div>
                      )}
                  </div>

                  {error.content_path && (
                    <small className="error_message">
                      {error.content_path}
                    </small>
                  )}
                </div>
              </div>
            </form>
          </fieldset>
        </div>
        <div className="col-md-12 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/CourseManagement/1"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Course" : "Back to Course Management"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Course
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
